module.exports = __webpack_public_path__ + "static/img/bank-one.9844f53.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/bank-one.svg
// module id = DyZu
// module chunks = 1